module.exports = __webpack_public_path__ + "img/aParty_110523_B.055f94ab.jpg";